<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "订单号",
            "code": "no",
            "basic": true
        }, {
            "type": "Text",
            "label": "合同单号",
            "code": "contractNo",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Text",
            "label": "交易单号",
            "code": "tradeNo",
            "basic": false
        }, {
            "type": "Select",
            "label": "配货方式",
            "valueType": "Boolean",
            "code": "manualAllocFlag",
            "dataList": [{
                "value": null,
                "label": "- 全部 -"
            }, {
                "value": "true",
                "label": "手工配货"
            }, {
                "value": "false",
                "label": "自动配货"
            }],
            "basic": true
        }, {
            "type": "Date2",
            "valueType": "String",
            "label": "创建时间",
            "code": "createTime",
            "basic": true
        }]
    };

    export default {
        name: 'swb-goods-order-search',
        desc: '商品订单管理搜索',
        props: {
            no: {
                type: String,
                default: null
            },
            isContract: {
                type: Boolean,
                default: false
            },
            contractId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                //排序、搜索
                queryConfig: null,
                queryKey: null
            }
        },
        created: function () {
            this.initQuery();
        },
        methods: {
            //
            initQuery: function () {
                //----------------------搜索排序----------------------------
                //查询排序配置信息
                let queryConfig = Utils.merge({}, searchConfigData);
                //查询回调函数调用上下文对象
                //queryConfig.queryContext = this;
                //
                let queryConfigMap = queryConfig.queryFields.toMap("code");
                if(!Utils.isNoB(this.no)) {
                    let noItem = queryConfigMap['no'];
                    noItem.value = this.no;
                }
                //
                let item = queryConfigMap["contractNo"];
                let item2 = queryConfigMap["tradeNo"];
                let isContract = this.isContract || false;
                if(isContract) {
                    if(!Utils.isNoB(this.contractId)) {
                        item.hidden = true;
                    }
                    item2.basic = false;
                } else {
                    item.hidden = true;
                }
                //
                this.queryConfig = queryConfig;
            },
            //
            queryHandler(queryModel) {
                //缓存查询条件
                this.$emit('showSearch', queryModel);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsOrderSearch.vue